<template>
  <v-dialog v-model="shown" max-width="500">
    <v-card class="pa-2">
      <v-card-title class="headline">
        {{ $t('common.attention') }}
      </v-card-title>

      <v-card-text>
        <span
          v-html="
            $t(
              'ai_features.user_access_control.user_unlimited_tokens_monthly_limit_confirmation',
              {
                userName: this.getFullName(account),
              }
            )
          "
          class="body-2 blue-grey--text text--darken-3"
        />
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn plain @click="$emit('cancel')">{{
          $t('common.button.cancel')
        }}</v-btn>

        <v-btn color="primary" plain @click="$emit('confirm')">{{
          $t('common.button.continue')
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import mixin from '@/mixins/mixin.vue'

export default {
  name: 'UserUnlimitedTokensConfirmation',

  mixins: [mixin],

  props: {
    shown: {
      type: Boolean,
      required: true,
    },
    account: {
      type: Object,
      required: false,
    },
  },
}
</script>
